export default {
  AS: {
    "footer.button.billOfMaterials": "onderdelenlijst",
    "footer.button.export": "Export",
    "footer.button.printPdf": "PDF",
    "footer.button.contactSales": "Verkoop Contact",
    "footer.button.addToWatchlist": "Toevoegen aan favorieten",
    "footer.button.requestQuote": "Offerte aanvragen",
    "header.configurator.title": "Configurator",

    "header.links.about.label": "over Asecos",
    "header.links.about.url":
      "https://www.asecos.com/Over-asecos/Over-asecos/Over-asecos/NL_index_3187.html,",
    "header.links.terms.label": "AV",
    "header.links.terms.url":
      "https://www.asecos.com/Algemene-Voorwaarden/NL_index_1724.html,",
    "header.links.imprint.label": "impressum",
    "header.links.imprint.url":
      "https://www.asecos.com/Impressum-/NL_index_1438.html,",
    "header.links.privacy.label": "Privacybeleid",
    "header.links.privacy.url":
      "https://www.asecos-configurator.com/NL/NL/privacybeleid",

    "dialog.requestQuote.title.success": "Aanvraag verzonden",
    "dialog.requestQuote.title.requestQuote": "offerte aanvragen",
    "tab.billOfMaterials.title": "onderdelenlijst",
    "tab.configurationSummary.title": "Samenvatting van de configuratie",
    "dialog.requestQuote.title.contactData": "Contactgegevens",
    "dialog.requestQuote.title.companyData": "Bedrijfsgegevens",
    "dialog.requestQuote.label.salutation": "Aanspreektitel",
    "dialog.requestQuote.select.salutation.option.female": "Mevrouw",
    "dialog.requestQuote.select.salutation.option.male": "De heer",
    "dialog.requestQuote.select.salutation.option.none": "--",

    "dialog.requestQuote.label.firstName": "Voornaam",
    "dialog.requestQuote.label.lastName": "Achternaam",
    "dialog.requestQuote.label.email": "E-mail",
    "dialog.requestQuote.label.phone": "Telefoon",
    "dialog.requestQuote.label.company": "Bedrijf",
    "dialog.requestQuote.label.country": "Land",
    "dialog.requestQuote.label.postalCode": "Postcode",
    "dialog.requestQuote.label.city": "Plaats",
    "dialog.requestQuote.label.street": "Straat",
    "dialog.requestQuote.label.number": "Nr",
    "dialog.requestQuote.label.contactHours": "Ik wil graag teruggebeld worden",
    "dialog.requestQuote.checkbox.contactHours.option.morning": "Ochtend",
    "dialog.requestQuote.checkbox.contactHours.option.afternoon": "Middag",
    "dialog.requestQuote.label.specialistRetailer.header":
      "Hier kunt u de dealer van uw voorkeur invoeren (indien bekend)",

    "dialog.requestQuote.label.specialistRetailer.salutation": "Aanspreektitel",
    "dialog.requestQuote.select.specialistRetailer.salutation.option.female":
      "Mevrouw",
    "dialog.requestQuote.select.specialistRetailer.salutation.option.male":
      "De heer",
    "dialog.requestQuote.select.specialistRetailer.salutation.option.none":
      "--",
    "dialog.requestQuote.label.specialistRetailer.company": "Bedrijf",
    "dialog.requestQuote.label.specialistRetailer.firstName": "Voornaam",
    "dialog.requestQuote.label.specialistRetailer.lastName": "Achternaam",
    "dialog.requestQuote.label.specialistRetailer.email": "E-mail",
    "dialog.requestQuote.label.specialistRetailer.city": "Plaats",
    "dialog.requestQuote.url.privacyPolicy":
      "https://www.asecos-configurator.com/NL/NL/privacybeleid",
    "dialog.requestQuote.url.consentForm":
      "https://www.asecos-configurator.com/NL/NL/media/DOK_EXT_Einwilligungserklaerung-asecos-Konfigurator_IN?sprache=NL",
    "dialog.requestQuote.label.readPrivacyPolicy":
      "Ik heb de <privacyLink>wettelijke kennisgeving</privacyLink> gelezen en ga akkoord. Ik stem in met de verwerking, het gebruik en de openbaarmaking van mijn gegevens aan een gespecialiseerde dealer in <consentLink>overeenstemming met de toestemming.</consentLink>",
    "dialog.requestQuote.label.comment": "Opmerking",
    "SubconfigurationNavigation.resetItem": "keuze resetten",
    "SubconfigurationNavigation.previousItem": "terug",
    "SubconfigurationNavigation.nextItem": "verder",
    "form.field.error.email": "E-mail ongeldig",
    "form.field.error.phone": "Telefoonnummer ongeldig",
    "validation.required": "Dit veld is verplicht",
    "footer.button.save": "downloaden",
    "footer.button.load": "uploaden",

    "dialog.requestQuote.success.message":
      "Hartelijk dank voor uw interesse in asecos en onze producten. Binnen enkele minuten ontvangt u een bevestiging op het door u opgegeven e-mailadres, inclusief uw configuratiegegevens als pdf- en JSON-bestand. Met dit laatste kunt u uw configuratie opnieuw openen via de knop ‘Uploaden’. \n\nasecos-producten worden verkocht via geautoriseerde dealers. Daarom sturen we uw aanvraag door naar een geschikte asecos-partner. Deze zal een vrijblijvende offerte opstellen op basis van uw configuratie en indien nodig contact met u opnemen.",
    "dialog.requestQuote.success.close": "Sluiten",
    "dialog.requestQuote.error.message":
      "Er is een fout opgetreden bij het verzenden van uw aanvraag. Probeer het later opnieuw",
  },
};
